import { useMemo } from "react";

import { ProductKey } from "@/components/signup/utils/products";

import {
    queryParam,
    useRegisterMetadata
} from "../hooks/use-registered-metadata";
import { ConfluenceProvisioningUi } from "../templates/confluence/confluence-provisioning-ui";
import { JiraProductDiscoveryProvisioningUi } from "../templates/jira-product-discovery/jpd-provisioning-ui";

import { DefaultProvisioningUI } from "./provisioning-flows/default-provisioning-ui";
import { JiraProvisioningUI } from "./provisioning-flows/jira-provisioning-ui";
import { ServiceCollectionProvisioningUI } from "./provisioning-flows/service-collection-provisioning-ui";
import { TeamWorkCollectionProvisioningUI } from "./provisioning-flows/teamwork-collection-provisioning-ui";

const {
    JIRA_SOFTWARE,
    JIRA_SERVICE_MANAGEMENT,
    LOOM,
    SERVICE_COLLECTION,
    TEAMWORK_COLLECTION,
    CONFLUENCE,
    JIRA_PRODUCT_DISCOVERY
} = ProductKey;

/**
 * Component renders the appropriate UI given the product(s)
 * @returns @type {JSX.Element}
 */
export const ProductViewSwitch = ({ subAnchor }: { subAnchor?: string }) => {
    const metadata = useRegisterMetadata();
    const orderedProductsKeys = useMemo(() => {
        const items = (metadata?.get(queryParam.products) as string[]) ?? [];
        return items.sort().join(",");
    }, [metadata]);

    switch (orderedProductsKeys) {
        case JIRA_SOFTWARE:
            return <JiraProvisioningUI />;
        case CONFLUENCE:
            return <ConfluenceProvisioningUi subAnchor={subAnchor} />;
        case TEAMWORK_COLLECTION:
            return <TeamWorkCollectionProvisioningUI />;
        case SERVICE_COLLECTION:
            return <ServiceCollectionProvisioningUI />;
        case JIRA_PRODUCT_DISCOVERY:
            return <JiraProductDiscoveryProvisioningUi />;
        case JIRA_SERVICE_MANAGEMENT:
        case LOOM:
        default:
            return <DefaultProvisioningUI />;
    }
};
